import { IService, ServiceType, ServiceManager } from "../ServiceManager";
import { Coordinate } from "../../types";
import { BrowserStorageService } from "../BrowserStorageService";

interface GeocoderCacheEntry {
  Address: string;
  Coordinate: Coordinate;
}

class GeocoderCache implements IService {
  Type: ServiceType = ServiceType.GeocoderCache;
  Id: string = 'GeocoderCache';
  private StorageKey = 'PROList.GeoCache';
  private StorageService: BrowserStorageService;

  constructor() {
    this.StorageService = ServiceManager.Require<BrowserStorageService>(ServiceType.BrowserStorage);
  }

  private GetCache(): GeocoderCacheEntry[] {
    const results = this.StorageService.getItem(this.StorageKey);

    if(results) {
      return JSON.parse(results);
    }

    return [];
  }

  private SetCache(items: GeocoderCacheEntry[]) {
    this.StorageService.setItem(this.StorageKey, JSON.stringify(items));
  }

  Get(address: string): GeocoderCacheEntry | undefined {
    const cache = this.GetCache();

    return cache.find((entry) => entry.Address == address);
  }

  Set(address: string, coord: Coordinate): void {
    const cache = this.GetCache();

    if(cache.some((entry) => entry.Address == address)) return;

    cache.push({
      Address: address,
      Coordinate: coord
    });

    this.SetCache(cache);
  }
}

export { GeocoderCache }
